// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#status-control {\n  position: absolute;\n  max-width: 300px;\n  height: 20px;\n  background: rgba(0,60,136,0.5);\n  bottom: 25px;\n  right:0;\n  margin:auto;\n  margin-bottom: 9px;\n  margin-right: 9px;\n  border-radius: 4px;\n\n}\n\n#status-control span {\n  color: white;\n}\n", ""]);
// Exports
module.exports = exports;
